<template>
	<tr @click="clickRow">
		<td>
			<v-btn
				v-if="!editMode"
				small
				icon
				:ripple="false"
			>
				<v-icon>
					{{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
				</v-icon>
			</v-btn>
		</td>
		<td class="text-center">
			{{ item.num }}
		</td>
		<td class="text-center"
			:style="editMode ? 'min-width: 250px;' : 'min-width: 200px;'"
		>
			<template v-if="editMode">
				<a-text-field-inline
					v-model="item.name"
					required
					single-line
				>
					<template v-slot:label v-if="!item.name && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-text-field-inline>
			</template>
			<template v-else>
				{{ item.name }}
			</template>
		</td>
		<td class="text-center"
			v-if="!createMode"
			:style="editMode ? 'min-width: 250px;' : 'min-width: 200px;'"
		>
			<template v-if="editMode">
				<a-text-field-inline
					v-model="item.chars"
				></a-text-field-inline>
			</template>
			<template v-else>
				<template v-if="linkifiedChars.length > limitChars && !expandChars">
					<span v-text="shortenedChars" @click="expandChars = true" style="cursor: pointer;"></span>
				</template>
				<template v-else>
					<span v-html="linkifiedChars"></span>
				</template>
			</template>
		</td>
		<td class="text-no-wrap text-center"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode">
				<a-text-field-inline
					v-model="item.unit"
					required
					single-line
				>
					<template v-slot:label v-if="!item.unit && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-text-field-inline>
			</template>
			<template v-else>
				{{ item.unit }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			:style="editMode ? 'min-width: 85px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.qtyMin"
					digits="0"
					:validate-on-blur="true"
					:rules="[ v => (v != '0') || 'Обязательное поле' ]"
				>
					<template v-slot:prepend-inner v-if="(item.qtyMin == 0) && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-number-field-inline>
			</template>
			<template v-else>
				{{ item.qtyMin }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			:style="editMode ? 'min-width: 85px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.qtyMax"
					digits="0"
					:validate-on-blur="true"
					:rules="[ v => (v != '0') || 'Обязательное поле' ]"
				>
					<template v-slot:prepend-inner v-if="(item.qtyMax == 0) && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-number-field-inline>
			</template>
			<template v-else>
				{{ item.qtyMax }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			v-if="!createMode"
			:style="editMode ? 'min-width: 85px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.consumption"
					digits="0"
					:validate-on-blur="true"
					:rules="[ v => (v != '0') || 'Обязательное поле' ]"
				>
					<template v-slot:prepend-inner v-if="(item.consumption == 0) && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-number-field-inline>
			</template>
			<template v-else>
				{{ item.consumption }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			v-if="!createMode"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.deliveryTime"
					digits="0"
					:validate-on-blur="true"
					:rules="[ v => (v != '0') || 'Обязательное поле' ]"
				>
					<template v-slot:prepend-inner v-if="(item.deliveryTime == 0) && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-number-field-inline>
			</template>
			<template v-else>
				{{ item.deliveryTime }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			v-if="!createMode"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.orderMin"
					digits="0"
				></a-number-field-inline>
			</template>
			<template v-else>
				{{ item.orderMin }}
			</template>
		</td>
		<td class="text-no-wrap text-center"
			v-if="!createMode"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode">
				<a-number-field-inline
					v-model="item.shelfLife"
					digits="0"
				></a-number-field-inline>
			</template>
			<template v-else>
				{{ item.shelfLife }}
			</template>
		</td>
		<td v-if="!editMode && !createMode"
			class="text-no-wrap text-center"
		>
			{{ item.stats && item.stats.last.priceNet > 0 ? item.stats.last.priceNet : '-' }}
		</td>
		<td v-if="createMode"
			class="text-no-wrap text-center"
			style="width: 150px"
		>
			<a-number-field-inline
				v-model="qtyStock"
				digits="0"
			></a-number-field-inline>
		</td>
		<td v-if="createMode"
			class="text-no-wrap text-center"
			style="width: 150px"
		>
			<a-number-field-inline
				v-model="item.qtyOrder"
				digits="0"
				:validate-on-blur="true"
				:rules="[ v => (v != '0') || 'Обязательное поле' ]"
			>
				<template v-slot:prepend-inner v-if="(item.qtyOrder == 0) && showErrors">
					<span class="error--text caption text-no-wrap">Обязательное поле</span>
				</template>
			</a-number-field-inline>
		</td>
		<td v-if="createMode"
			class="text-no-wrap text-center"
			style="width: 150px"
		>
			<a-number-field-inline
				v-model="item.priceNetOrder"
				digits="2"
				:validate-on-blur="true"
				:rules="[ v => (v != '0') || 'Обязательное поле' ]"
			>
				<template v-slot:prepend-inner v-if="(item.priceNetOrder == 0) && showErrors">
					<span class="error--text caption text-no-wrap">Обязательное поле</span>
				</template>
			</a-number-field-inline>
		</td>
		<td class="text-center"
			v-if="!createMode"
			:style="editMode ? 'min-width: 250px;' : 'min-width: 200px;'"
		>
			<template v-if="editMode">
				<a-text-field-inline
					v-model="item.notes"
					single-line
				></a-text-field-inline>
			</template>
			<template v-else>
				{{ item.notes }}
			</template>
		</td>

		<td v-if="editMode" class="text-no-wrap text-center">
			<v-tooltip
				bottom
				open-delay="300"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="copy"
					>
						file_copy
					</v-icon>
				</template>
				<span>Копировать строку</span>
			</v-tooltip>
			<v-tooltip
				bottom
				open-delay="300"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="remove"
					>
						delete
					</v-icon>
				</template>
				<span>Удалить строку</span>
			</v-tooltip>
			<v-tooltip
				bottom
				open-delay="300"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="down"
						:disabled="item.num == length"
					>
						keyboard_arrow_down
					</v-icon>
				</template>
				<span>Вниз</span>
			</v-tooltip>
			<v-tooltip
				bottom
				open-delay="300"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="up"
						:disabled="item.num == 1"
					>
						keyboard_arrow_up
					</v-icon>
				</template>
				<span>Вверх</span>
			</v-tooltip>
		</td>
	</tr>
</template>

<script>
	import _ from 'lodash'
	import { toStr, toNum, linkify } from '../../../js/common'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'
	import aTextFieldInline from '../../base/ATextFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
			aTextFieldInline
		},
		props: {
			createMode: Boolean,
			editMode: Boolean,
			expanded: {
				type: Boolean,
				default: false
			},
			item: {
				type: Object,
				default: function () {
					return {
						num: 0,
						name: '',
						chars: '',
						unit: '',
						qtyMin: '',
						qtyMax: '',
						consumption: '',
						deliveryTime: '',
						orderMin: '',
						shelfLife: '',
						priceNetLast: '',
					}
				}
			},
			length: Number,
			showErrors: Boolean,
		},
		data: () => ({
			expandChars: false,
			limitChars: 50,
			qtyStock: 0,
		}),
		computed: {
			shortenedChars() {
				return this.item.chars.substring(0, this.limitChars) + '...'
			},
			linkifiedChars() {
				return linkify(this.item.chars)
			},
		},
		methods: {
			clickRow() {
				if (this.editMode || this.createMode) return
				else this.$emit('expand')
			},
			down() {
				this.$emit('down', this.item.num)
			},
			copy() {
				this.$emit('copy', this.item.num)
			},
			remove() {
				this.$emit('remove', this.item.num)
			},
			toStr(val) {
				return toStr(val)
			},
			up() {
				this.$emit('up', this.item.num)
			},
		},
		watch: {
			qtyStock(val, old) {
				// console.log('watcher qtyStock ' + val)
				val = toNum(val)
				if (val >= 0) {
					let qtyOrder = toStr(toNum(this.item.qtyMax) - val, 0)
					this.$emit('update:qtyOrder', qtyOrder)
				}
			},
		},
	}
</script>

<style scoped>

</style>
